import React, { useEffect, useRef, useState } from "react";
import { width, height } from "../../../CustomComponents/Card/CardStyles";
import { useTranslation } from "react-i18next";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import right_dropdown_arrow from "../../../../assets/images/right_dropdown_arrow.png";
import CustomTextInput from "../../../CustomComponents/CustomtextInput";
import Loader from "../../../CustomComponents/Loader";
import Modal from "../../../CustomComponents/Modal";
import {
  GetApiHeadersWithBearer,
  GetRequest,
  PostRequest,
} from "../../../../network/NetworkUtils";
import { useNavigate } from "react-router-dom";
import {
  appTheme,
  fetchConfigarationData,
  retrieveData,
} from "../../../../helpers/utils/Utils";
import CustomAlertModel from "../../../CustomComponents/CustomAlertModel";
import { withOidcSecure } from "@axa-fr/react-oidc";
import Footer from "../../../Layout/Footer";
import HomeLayout from "../../../Layout/HomeLayout";
import HomeHeader from "../../../CustomComponents/HomeHeader";
import DynamicCard from "../../../CustomComponents/DynamicHomeCard";
import { useKeyDown } from "../../../../hooks/useKeyDown";
import statement_page from "../../../../assets/images/statement_page.png";
import shredding_statement from "../../../../assets/images/shredding_statement.png";
import Bell from "../../../../assets/images/Bell.png";
import LeftBar from "../../../CustomComponents/DynamicComponent/LeftBar";
import arrow from "../../../../assets/images/Caret_S.png";
import HtmlDropDown from "../../../CustomComponents/HtmlDropDown";
import { AGREEMENTS, STATUS_SUCCESS_CODE } from "../../../../network/URLConstants";
import HtmlNavigation from "../../../CustomComponents/HtmlNavigation";
import CardHeading from "../../../CustomComponents/CardHeading";
import { getUserMembership } from "../../../../helpers/utils/Utils";
import logFirebaseEvents from "../../../LogFirebaseEvents";

// Policy changes

const KudzuPolicies = () => {
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);

  const { t } = useTranslation(); // Hook to access translation functions
  const [height, setHeight] = useState(0);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
  const [isMobileVerificationModalOpen, setisMobileVerificationModalOpen] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState("");
  const [highlightMsg, setHighlightMsg] = useState("");
  const [headerMsg, setheaderMsg] = useState("");
  const [subHeaderMsg, setSubHeaderMsg] = useState("");
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [btn1Text, setBtn1Text] = useState(false);
  const [btn2Text, setBtn2Text] = useState("");
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [type, setType] = useState("");
  const [footerMsg, setFooterMsg] = useState("");
  const [displayContent, setDisplayContent] = useState({});
  const [accountType, setAccountType] = useState({});
  const isSmiOneIsTrue = useSelector((state) => state.smiOneAccountTrue);
  const dispatch = useDispatch();
  const loggedResponse = useSelector((state) =>
    JSON.parse(state.loggedInResponse)
  );
  const userMembershipData = getUserMembership(loggedResponse);

  const cardKey = cards?.find(card => card.AccountTypeBit63 === 64)?.CardKey;

  const [agreementType, setAgreementType] = useState([
    {
      name: "Electronic Communications Disclosure and Agreement",
      url: "ESign",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Bancorp Privacy Notice",
      url: "PrivacyPolicyV2",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Kudzu User Agreement",
      url: "TnC",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Kudzu Privacy Policy",
      url: "PPrivacyPolicy",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Demand Deposit Account Agreement",
      url:
        userMembershipData?.membershipType === "Plus" ||
        userMembershipData?.membershipType === "Trial"
          ? "KudzuPlusDepositTerms"
          : "DepositTerms",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Covered by Kudzu Terms and Conditions",
      url:
        userMembershipData?.membershipType === "Plus" ||
        userMembershipData?.membershipType === "Trial"
          ? "CoveredByKudzuPlusTerms"
          : "CoveredByKudzuTerms",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Fees",
      url:
        userMembershipData?.membershipType === "Plus" ||
        userMembershipData?.membershipType === "Trial"
          ? "KudzuPlusFeeMastersV2"
          : "FeeMastersV2",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Kudzu Alerts Terms Of Servies",
      url: "SMSTerms",
      accType: 64,
      CardKey: cardKey,
    },
    {
      name: "Official Sweepstakes Rules",
      url: "PayPerkSweepstakesRules",
      accType: 64,
      CardKey: cardKey,
    },
  ]);

  const redirectToPolicy = (policyName) => {
    const selectedAgreementType = agreementType.find(agreement => agreement.url === policyName);
    dispatch({
      type: "UPDATE_AGREEMENT_TYPE",
      payload: { documentAgreementType: selectedAgreementType },
    });
    navigate(`/Documents/Kudzu/Policies/${selectedAgreementType.name}`);
  };

  const [toNavigate, setToNavigate] = useState("");
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);

  useKeyDown(() => {}, ["Enter"]);
  useEffect(() => {
    const hasSavingsAccount = cards?.some(
      (item) => item.AccountTypeName === "Savings" && item.ProgramKey === 200
    );
    if (hasSavingsAccount) {
      agreementType.splice(5, 0, {
        name: "Savings Account Agreement",
        url:
          userMembershipData?.membershipType === "Plus" ||
          userMembershipData?.membershipType === "Trial"
            ? "KudzuPlusTnC"
            : "TnC",
        accType: 32,
        CardKey: cards?.[1]?.CardKey,
      });
      // agreementType.push(...[{ name: 'Savings Account Agreement', url: 'TnC', accType: 32, CardKey: cards?.[1]?.CardKey }, { name: 'Savings Rate Information', url: 'SavingsRateInfo', accType: 32, CardKey: cards?.[0]?.CardKey }]);
      agreementType.push(
        ...[
          {
            name: "Savings Rate Information",
            url: "SavingsRateInfo",
            accType: 32,
            CardKey: cards?.[0]?.CardKey,
          },
        ]
      );
    }
  }, []);

  const leftBarComp = () => {
    return (
      <>
        <div className="lg:w-[260px] md:w-[183px] sm:w-[164px] w-full sm:mx-0 ml-[2.5rem]">
          <p
            className="text-white font-normal
                    lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]
                    sm:leading-[30px] leading-[31px]
          font-serif-pro sm:border-b-[2.5px] sm:border-[#4B70B9] lg:pb-14 md:pb-[50px]  sm:border-opacity-[50%]
          sm:pb-[2.6rem] pb-[2.6rem] mb-10"
          >
            {t("easily_access_policy")}
          </p>
          <div className="flex flex-col gap-4 text-white w-[80%]">
            {/* Kudzu Header */}
            <div
              className="text-white font-bold text-[16px] cursor-pointer"
              onClick={() => navigate("/Documents/smiONE")}
            >
              {"smiONE"}
            </div>
          </div>
          <div className="flex pt-4 flex-col gap-4 text-white w-[80%]">
            {/* Kudzu Header */}
            <div
              className="text-white font-bold text-[16px] cursor-pointer"
              onClick={() => navigate("/Documents/Kudzu")}
            >
              {"Kudzu"}
            </div>
            <div className="flex flex-col gap-2 ml-5 transition-all duration-300 ease-in-out">
              {/* Statements */}
              {cards?.[0]?.EnableStatements && (
                <div
                  className="pb-2 cursor-pointer"
                  onClick={() => {
                    navigate("/Documents/Kudzu/Statements");
                    logFirebaseEvents(
                      "Documents",
                      "Statement_Clicked",
                      "Statement_Clicked",
                      "",
                      ""
                    );
                  }}
                >
                  <p className="font-hanken-grotesk font-semibold text-[15px] text-[#FEFAEE]">
                    {t("statements")}
                  </p>
                </div>
              )}

              {/* Policies Dropdown */}
              <div className="flex flex-col gap-6">
                <div
                  className="font-hanken-grotesk font-semibold text-[15px] text-[#94C3E8] cursor-pointer"
                  onClick={() => navigate("/Documents/Kudzu/Policies")}
                >
                  {t("privacy_and_legal")}
                </div>
                <div className="flex flex-col gap-6 ml-5 w-[235px]">
                  <p
                    className="cursor-pointer text-white font-[600]"
                    onClick={() => redirectToPolicy("ESign")}
                  >
                    {t("ElectronicAggrement")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy("PrivacyPolicyV2")}
                  >
                    {t("bancorp_Notice")}
                  </p>

                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy("TnC")}
                  >
                    {t("kudzu_user_agreement")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy("PPrivacyPolicy")}
                  >
                    {t("kudzu_privacy_policy")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy(userMembershipData?.membershipType === "Plus" ? "KudzuPlusDepositTerms" : "DepositTerms")}
                  >
                    {t("demand_deposit_account")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy(userMembershipData?.membershipType === "Plus" ? "KudzuPlusTnC" : "TnC")}
                  >
                    {t("savings_account_agreement")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy(userMembershipData?.membershipType === "Plus" ? "CoveredByKudzuPlusTerms" : "CoveredByKudzuTerms")}
                  >
                    {t("covered_by_kudzu")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy(userMembershipData?.membershipType === "Plus" ? "KudzuPlusFeeMastersV2" : "FeeMastersV2")}
                  >
                    {t("fees")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy("SMSTerms")}
                  >
                    {t("sms_terms_of_service")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy("PayPerkSweepstakesRules")}
                  >
                    {t("official_sweepstake")}
                  </p>
                  <p
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer"
                    onClick={() => redirectToPolicy("SavingsRateInfo")}
                  >
                    {t("savings_rate")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <HomeLayout>
        <LeftBar
          leftBarType="component"
          isPrimary={true}
          leftBarComp={leftBarComp()}
        />
        <div className="md:w-[150px] sm:w-[70px] w-[0px]"></div>

        <div className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight ">
          <DynamicCard
            cardWidth={width.allpolicies}
            header={true}
            footer={false}
            // headerContent={headerContent()}
            footerContent={() => {}}
            CardRadius={true}
            isWhite={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            backgroundColor={"--cardHeading-bg"}
            HeaderContent={
              <>
                <CardHeading heading={t("privacy_and_legal")} />
              </>
            }
            HeaderRadius={true}
          >
            <div className="w-full flex flex-col">
              <div className="w-full flex flex-col justify-center">
                <div
                  className={`flex flex-col ${
                    kudzuPlusTrue ? "" : "border-t-[2.5px] border-[#A3CEBB]"
                  } mb-5 
                                 sm:mx-0 mx-4}`}
                ></div>

                <div
                  className="flex sm:w-full flex-col text-[var(--Policies-select-clr)] md:text-[20px] 
                                sm:text-[12px]  text-[14px] my-5 font-hanken-grotesk 
                                sm:font-[500] font-[400] md:leading-[30px] sm:leading-[18px] leading-[20px] sm:mx-0 mx-4"
                >
                  {t("select_a_document_below_to_view")}
                </div>

                <div className="pb-[5rem] sm:mx-0 mx-4">
                  {agreementType.map((item, index) => (
                    <div key={index} className="w-full flex flex-col">
                      <HtmlNavigation agreementType={item} isKudzu={true}  />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </DynamicCard>
          {loading && <Loader />}
        </div>
      </HomeLayout>
    </>
  );
};

export default withOidcSecure(KudzuPolicies);
